import { Input } from '@src/design-system/input';
import { Label } from '@src/design-system/label';
import { CloseCircle } from 'iconsax-react';
import { CircleCheck, LoaderCircle } from 'lucide-react';
import { type FC, useEffect, useState } from 'react';
import universityStatusesApi from '../../../services/university-statuses-api';

type EditStatusProps = {
  isEditing: boolean;
  value: string;
  editingId?: number;
  onClose: () => void;
  onConfirm?: (val: string) => void;
  isPending?: boolean;
};

const EditUniversityStatusInput: FC<EditStatusProps> = ({
  isEditing,
  value,
  onClose,
  editingId,
  onConfirm,
  isPending,
}) => {
  const [inputValue, setInputValue] = useState<string>('');

  const { mutateAsync: editUniversityStatus, isPending: editUniversityStatusPending } =
    universityStatusesApi.useUpdate();

  const handleEditStatus = () => {
    if (onConfirm) {
      onConfirm(inputValue);
      return;
    }
    if (inputValue && editingId) {
      editUniversityStatus({ name: inputValue, id: editingId }).then(onClose);
    }
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <>
      {isEditing ? (
        <div className='flex gap-2 items-center'>
          <Input
            size='xs'
            className='text-sm'
            defaultValue={value}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleEditStatus();
              }
            }}
            suffexIcon={
              <div className='text-black flex gap-1 items-center'>
                <CloseCircle
                  onClick={onClose}
                  size={16}
                  className='cursor-pointer opacity-80 hover:opacity-100'
                />
                <CircleCheck
                  onClick={handleEditStatus}
                  size={18}
                  className='cursor-pointer stroke-[1.5px] text-white fill-green-500'
                />
              </div>
            }
          />
          {editUniversityStatusPending ||
            (isPending && (
              <LoaderCircle
                className='animate-spin'
                size={20}
              />
            ))}
        </div>
      ) : (
        <Label
          htmlFor={''}
          className='text-sm text-gray-700 mb-0 capitalize'
        >
          {value}
        </Label>
      )}
    </>
  );
};

export default EditUniversityStatusInput;
